<template>
  <tr>
    <td class="align-middle">{{ visaData.name }}</td>
    <td class="align-middle">{{ visaData.country_name }}</td>
    <td class="align-middle" style="width: 120px;">{{ visaData.valid_for }}</td>
    <td class="align-middle" style="width: 120px;">{{ visaData.end_date }}</td>
    <td style="width: 140px;" class="align-middle">
      <d-button
        theme="primary"
        @click.native="editVisa"
        class="mr-2"
        title="Edit">
        <i class="material-icons">edit</i>
      </d-button>
      <d-button
        theme="danger"
        :disabled="removeInProgress"
        @click.prevent="removeVisa"
        title="Delete">
        <i class="material-icons">delete</i>
      </d-button>
    </td>
  </tr>
</template>

<script>
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'visas-list-item',
  props: {
    visaData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data () {
    return {
      removeInProgress: false
    };
  },
  methods: {
    removeVisa () {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/visas/delete/',
        id: parseInt(this.visaData.id, 10),
        successTitle: 'Visa removed',
        successText: 'The selected visa has been removed',
        confirmTitle: 'Do you really want to remove this visa?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('visas-list-reload');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    editVisa () {
      this.$bus.$emit('show-visa-popup', 'edit', false, false, this.visaData.id);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
